import { Result, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import '../../../src/RetailApp.scss';
import '../../../src/retail-antd-custom.scss';
import '../../../src/design-system.scss';
import retailApi from '../../api/retailApi';
import Footer from '../../components/Retail/Footer/Footer';
import Header from '../../components/Retail/Header/Header';
import NavbarFooter from '../../components/Navbar/NavbarFooter';
import { errorNotification } from '../../components/UI/Toast/Toast';
import useBrokerConfig from '../../hooks/useBrokerConfig';
import Router from '../../router/Router';
import { fetchUserDetails } from '../../store/auth';
import { errorHandler, getRetailAccessToken, setLocalData } from '../../utils/helper';

const ORPLayout: React.FC = (props: any) => {
  const referrer = document.referrer,
    location = useLocation(),
    dispatch = useDispatch(),
    userData = useSelector((state: any) => state.auth),
    { loading: brokerLoading, theme, fetchBrokerConfig } = useBrokerConfig(),
    [loading, setLoading] = useState(true),
    [validReferrer, setValidReferrer] = useState(false),
    [partner, setPartner] = useState(undefined as any),
    navigate = useNavigate(),
    // Logged-in users on broker deals get the app's bottom tab bar on mobile; partner pages don't.
    showMobileNav = !!getRetailAccessToken() && !partner,
    getPartnerDetails = () => {
      retailApi.partner.getPartnerDetails({ slug: partner })
        .then((res) => {
          if (res?.data?.referral === null || res?.data?.referral?.length === 0 || res?.data?.referral?.includes(referrer)) {
            setValidReferrer(true);
            setLoading(false);
          }
          else {
            setValidReferrer(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          errorHandler(err?.response?.data);
        })
    };

  useEffect(() => {
    const routePattern = "/wellness/:partner/*";
    const match = matchPath(routePattern, location.pathname);

    if (match) {
      const partner = match?.params?.partner;
      if (partner && !["product", "offer", "checkout", "post-payment"].includes(partner)) {
        setPartner(partner);
      } else {
        setPartner(undefined);
        if (getRetailAccessToken()) {
          setValidReferrer(true);
          if (!userData?.member_uuid) {
            dispatch(fetchUserDetails() as any).then((res: any) => {
              fetchBrokerConfig(res?.payload?.organisation_uuid);
              setLoading(false);
            });
          } else {
            fetchBrokerConfig(userData?.organisation_uuid);
            setLoading(false);
          }
        }
      }
    }
    else {
      setTimeout(() => {
        if (!getRetailAccessToken()) {
          errorNotification('Please login to access the page');
          setLocalData('targetUrl', window.location.href.split('/').slice(3, 0).join('/'));
          navigate('/');
        } else {
          setValidReferrer(true);
          if (!userData?.member_uuid) {
            dispatch(fetchUserDetails() as any).then((res: any) => {
              fetchBrokerConfig(res?.payload?.organisation_uuid);
              setLoading(false);
            });
          } else {
            fetchBrokerConfig(userData?.organisation_uuid);
            setLoading(false);
          }
        }
      }, 2000)
    }
  }, [location]);

  useEffect(() => {
    if (partner && partner !== 'checkout') {
      getPartnerDetails();
      if (userData?.organisation_uuid) {
        fetchBrokerConfig(userData?.organisation_uuid);
      } else if (getRetailAccessToken()) {
        dispatch(fetchUserDetails() as any).then((res: any) => {
          fetchBrokerConfig(res?.payload?.organisation_uuid);
        });
      }
    }
    else {
      if (getRetailAccessToken()) {
        setValidReferrer(true);
        if (!userData?.member_uuid) {
          dispatch(fetchUserDetails() as any).then((res: any) => {
            fetchBrokerConfig(res?.payload?.organisation_uuid);
            setLoading(false);
          });
        } else {
          fetchBrokerConfig(userData?.organisation_uuid);
          setLoading(false);
        }
      }
    }
  }, [partner]);

  useEffect(() => {
    document.title = theme.title + ': ' + theme.description;
    document.querySelector('meta[name="description"]')?.setAttribute('content', theme.description);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme.primaryColor);
    document.querySelector('meta[name="msapplication-navbutton-color"]')?.setAttribute('content', theme.primaryColor);
    document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')?.setAttribute('content', theme.primaryColor);
    let link: any = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = theme.favicon;

    // Dynamic manifest
    var myDynamicManifest = {
      "name": theme.title,
      "short_name": theme.title,
      "description": theme.description,
      "background_color": "#000000",
      "theme_color": theme.primaryColor,
      "start_url": ".",
      "scope": ".",
      "display": "standalone",
      "icons": [
        {
          "src": theme.favicon,
          "sizes": "64x64 32x32 24x24 16x16",
          "type": "image/x-icon",
          "purpose": "any maskable"
        },
        {
          "src": theme.favicon,
          "sizes": "192x192",
          "type": "image/png",
          "purpose": "any maskable"
        },
        {
          "src": theme.favicon,
          "sizes": "512x512",
          "type": "image/png",
          "purpose": "any maskable"
        },
      ]
    }
    const stringManifest = JSON.stringify(myDynamicManifest);
    const blob = new Blob([stringManifest], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);
    let maniFest: any = document.querySelector("#my-manifest-placeholder");
    maniFest.href = manifestURL;
  }, [theme])

  return (
    <div>
      <Header />
      {(loading || (brokerLoading && !validReferrer)) &&
        !location.pathname.includes('post-payment') && (
          partner ? (
            <Result
              icon={<Spin />}
              style={{ marginTop: '20vh', marginBottom: '20vh' }}
              title="Checking Eligiblity"
              subTitle={`Checking if you are eligible to avail these offers.`}
            />
          ) : (
            <div className="loader-div" style={{ marginTop: '20vh', marginBottom: '20vh', textAlign: 'center' }}>
              <Spin size="large" />
            </div>
          )
        )}
      {!validReferrer && !loading && !brokerLoading &&
        <Result
          status="warning"
          style={{ marginTop: '20vh', marginBottom: '20vh' }}
          title="Invalid Referrer"
          subTitle={`You are not elgible for these offers.`}
        />
      }
      {validReferrer && !loading &&
        <Router />
      }
      <Footer />
      {showMobileNav && (
        <div className="show-on-mobile">
          <NavbarFooter />
        </div>
      )}
    </div>
  );
};

export default ORPLayout;